import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-bidding-deviation-report-page',
  templateUrl: './bidding-deviation-report-page.component.html',
  styleUrls: ['./bidding-deviation-report-page.component.css']
})
export class BiddingDeviationReportPageComponent implements OnInit {
  data: { invitation: any; deviations: any[]; summary: any } | null = null;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private toastr: ToastrMsgService
  ) {}

  ngOnInit(): void {
    const invitationId = this.route.snapshot.paramMap.get('invitationId');
    if (invitationId) {
      this.loadReport(+invitationId);
    } else {
      this.toastr.error('Invalid invitation');
      this.loading = false;
    }
  }

  loadReport(invitationId: number): void {
    this.apiService.getBiddingDeviationReport(invitationId).subscribe({
      next: (res: any) => {
        if (res.success && res.data) {
          this.data = res.data;
        } else {
          this.toastr.error(res.error || 'Failed to load deviation report');
        }
        this.loading = false;
      },
      error: (err) => {
        this.toastr.error(err.error?.error || 'Failed to load deviation report');
        this.loading = false;
      }
    });
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(amount || 0);
  }

  /** Deviation = estimated amount - bid amount. Positive = bid lower (savings), Negative = bid higher (over) */
  getDeviationAmount(d: { estimated_amount?: number; bidder_amount?: number; amount_deviation?: number }): number {
    if (d.estimated_amount != null && d.bidder_amount != null) {
      return (d.estimated_amount || 0) - (d.bidder_amount || 0);
    }
    return d.amount_deviation != null ? -(d.amount_deviation as number) : 0;
  }

  /** Returns CSS classes for deviation: green (bid lower) / red (bid higher) / neutral (zero) */
  getDeviationClass(deviation: number): string {
    if (deviation > 0) return 'text-green-600 font-medium';
    if (deviation < 0) return 'text-red-600 font-medium';
    return 'text-gray-600';
  }

  /**
   * Destination for the page header back button. Falls back to the BOQ
   * landing page when there's no invitation context (e.g. after a refresh
   * on a stale URL).
   */
  get backLink(): any[] {
    const invitationId = this.route.snapshot.paramMap.get('invitationId');
    return invitationId
      ? ['/home/boq-bidding/view-bids', invitationId]
      : ['/home/boq'];
  }
}
